import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import { useTheme } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import './App.css';

import DashboardScreen from './screens/Dashboard';
import Login from './screens/Login';
import ForgotPassword from './screens/ForgotPassword';
import SignUp from './screens/SignUp';
import Sidebar from './components/Sidebar';
import Settings from './screens/Settings';
import ServicesScreen from './screens/Services';
import AppointmentScreen from './screens/Appointments';
import ConversationScreen from './screens/Conversations';
import ReviewsScreen from './screens/Reviews';
import ClientsScreen from './screens/Clients';

const AuthRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/signup" element={<SignUp />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

const MainRoutes = () => (
  <div style={{ display: 'flex' }}>
    <Sidebar />
    <div style={{ flex: 1, padding: '20px', minWidth: 0, }}>
      <Routes>
        <Route path="/dashboard" element={<DashboardScreen />} />
        <Route path="/services" element={<ServicesScreen />} />
        <Route path="/appointments" element={<AppointmentScreen />} />
        <Route path="/chats" element={<ConversationScreen />} />
        <Route path="/clients" element={<ClientsScreen />} />
        <Route path="/reviews" element={<ReviewsScreen />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  </div>
);

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();
  const { theme } = useTheme();

  return (
    <div style={{ backgroundColor: theme === 'light' ? '#ffffff' : '#333333', color: theme === 'light' ? '#000000' : '#ffffff', minHeight: '100vh' }}>
      <Router>{isAuthenticated ? <MainRoutes /> : <AuthRoutes />}</Router>
    </div>
  );
};

const App = () => (
  <AuthProvider>
    <NotificationProvider>
      <AppRoutes />
    </NotificationProvider>
  </AuthProvider>
);

export default App;
